import React from 'react';

function cx(...classes) {
  return classes.filter(Boolean).join(' ');
}

const VARIANTS = {
  primary: 'bg-seha-500 text-white hover:bg-seha-800 shadow-sm border border-transparent',
  secondary: 'bg-white border border-neutral-200 text-neutral-700 hover:bg-neutral-50 dark:bg-ink-900 dark:border-neutral-700 dark:text-neutral-200 dark:hover:bg-ink-800',
  ghost: 'bg-transparent text-neutral-600 hover:bg-neutral-50 border border-transparent dark:text-neutral-300 dark:hover:bg-ink-800',
  danger: 'bg-white border border-red-200 text-red-600 hover:bg-red-50 dark:bg-ink-900 dark:border-red-500/20 dark:text-red-400 dark:hover:bg-red-500/10',
  inverse: 'bg-white/10 hover:bg-white/20 text-white border border-white/20',
};

const SIZES = {
  sm: 'px-3 py-1.5 text-xs',
  md: 'px-4 py-2 text-sm',
  lg: 'px-5 py-2.5 text-sm',
};

export default function Button({
  variant = 'primary',
  size = 'md',
  className = '',
  icon: Icon,
  children,
  ...rest
}) {
  return (
    <button
      className={cx(
        'inline-flex items-center justify-center gap-2 rounded-lg font-semibold transition-colors disabled:opacity-50 disabled:cursor-not-allowed',
        VARIANTS[variant] || VARIANTS.primary,
        SIZES[size] || SIZES.md,
        className
      )}
      {...rest}
    >
      {Icon && <Icon className="w-4 h-4" />}
      {children}
    </button>
  );
}
